import React from 'react';

import AssetProfile from './AssetProfile';

function ManageAssetProfile() {
	return <AssetProfile isManageAsset />;
}

export default ManageAssetProfile;
